import { render, staticRenderFns } from "./CustomDirectDebitModalButton.vue?vue&type=template&id=9d6b230e&"
import script from "./CustomDirectDebitModalButton.vue?vue&type=script&lang=js&"
export * from "./CustomDirectDebitModalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports